// Automatic token forwarding is limited to the approved H365 Sandbox payment flow.
export function getSandboxPaymentReturn(callback, accountOrigin) {
  if (accountOrigin !== 'https://ssaccount.h365.games' || typeof callback !== 'string') return null
  try {
    const target = new URL(callback)
    if (target.origin !== 'https://payment-sandbox-beta.h365.games' ||
        target.username || target.password || !/^\/payment\/detail\/\d+$/.test(target.pathname)) return null
    const language = target.searchParams.get('language')
    target.search = ''
    target.hash = ''
    if (['zh-TW', 'zh-CN', 'en-US'].includes(language)) target.searchParams.set('language', language)
    return target
  }
  catch (_) {
    return null
  }
}

export async function resumeSandboxPaymentReturn(target, store, navigate) {
  const token = store.state.token
  if (!token) return false
  try {
    const response = await store.dispatch('getUser', { silent: true, timeout: 15000 })
    // Do not forward a stale session if a concurrent sign-in/logout changed it.
    if (response?.isSuccess !== true || store.state.token !== token) return false
    const auth = new URL('/auth', target.origin)
    auth.searchParams.set('token', token)
    auth.searchParams.set('redirectUrl', target.toString())
    navigate(auth.toString())
    return true
  }
  catch (_) {
    return false
  }
}
